export function getFinancialApiUrl() {
    return WP_FINANCIAL_API_GRAPHQL;
}

function getFinancialApiKey() {
    return WP_FINANCIAL_API_KEY;
}

export const setHeader = { 'x-lendingtree-financial': getFinancialApiKey() };
